import { ToastContainer, toast } from 'react-toastify'
import { ThemeProvider } from '@/contexts/ThemeProvider'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AxiosProvider } from './AxiosProvider'
import ClerkThemeProvider from './ClerkThemeProvider'
import { SocketProvider } from './SocketProvider'
import { TooltipProvider } from '@/components/ui/tooltip'
import { ErrorBoundary } from '@/pages/Error'
import { AuthProvider } from './AuthProvider'

const queryClient = new QueryClient()

const GlobalWrapper = ({ children }) => {
  // Suppress error toasts in production across the app
  if (process.env.NODE_ENV === 'production') {
    ;(toast as any).error = () => {}
  }
  return (
    <>
      <ToastContainer
        toastClassName={() =>
          'relative flex py-4 px-3 rounded overflow-hidden cursor-pointer bg-white shadow-lg'
        }
        bodyClassName={() => 'text-black text-base font-normal'}
        position="bottom-left"
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop={false}
        closeButton={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <ClerkThemeProvider>
            <AxiosProvider>
              <SocketProvider>
                <TooltipProvider delayDuration={150} skipDelayDuration={0}>
                  <AuthProvider>{children}</AuthProvider>
                </TooltipProvider>
              </SocketProvider>
            </AxiosProvider>
          </ClerkThemeProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </>
  )
}

export default GlobalWrapper
